<template>
    <q-page>
        <div class="q-pa-md">
            <div class="text-h4">Lugares de Checado</div>
            <q-table 
                dense
                :pagination="{rowsPerPage:10}"
                :rows-per-page-options="[0]"
                virtual-scroll
                flat
                bordered
                :rows="lugaresChecado"
                separator="cell">
                <template v-slot:header>
                    <q-tr class="bg-dark text-white">
                        <q-th key="Descripcion"  align="left">Descripción</q-th>
                        <q-th auto-width key="Actions" align="center">
                            <q-btn icon="add" color="dark" size="sm" padding="5px 5px" @click="editLugarChecado(0)"/>
                        </q-th>
                    </q-tr>
                </template>
                <template v-slot:body="props">
                    <q-tr>
                        <q-td>{{ props.row.Descripcion }}</q-td>
                        <q-td>
                            <q-btn-group>
                                <q-btn icon="edit" color="secondary" size="sm" padding="5px 5px" @click="editLugarChecado(props.row.IdLugarChecado)"/>
                                <q-btn icon="delete" color="negative" size="sm" padding="5px 5px" @click="showLugarChecado(props.row.IdLugarChecado)"/>
                            </q-btn-group>
                        </q-td>
                    </q-tr>
                </template>
            </q-table>
        </div>
    </q-page>

    <q-dialog v-model="edit" persistent>
        <q-card style="width:700px; max-width:80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>Lugar de Checado</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="saveLugarChecado">
                    <q-input outlined dense v-model="lugarChecado.Descripcion" label="Descripción" :rules="rules"/>
                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="edit=false"/>
                            <q-btn color="primary" label="Guardar" type="submit"/>
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>

    <q-dialog v-model='del' persistent>
        <q-card style="width: 700px; max-width: 80vw;">
            <q-toolbar class="bg-dark text-white">
                <q-toolbar-title>¿Está seguro de eliminar el Lugar de Checado?</q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup />
            </q-toolbar>
            <q-card-section>
                <q-form class="q-gutter-md" @submit.prevent="delLugarChecado">
                    <q-input outlined disable dense v-model="lugarChecado.Descripcion" label="Descripción" :rules="rules"/>
                    <div>
                        <div class="q-pa-md q-gutter-sm float-right">
                            <q-btn color="secondary" text-color="white" label="Cerrar" @click="del=false"/>
                            <q-btn color="primary" label="Eliminar" type="submit"/>
                        </div>
                    </div>
                </q-form>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import http from "@/services/http"

export default {
data: () => ({
    lugaresChecado:[],
      lugarChecado:{},
      edit:false,
      del:false,
      rules: [v => !!v || 'Campo obligatorio',],
    }),
    methods:{
        async initialize(){
             this.lugaresChecado = await http.get('catalogos/lugaresChecado');
        },
        async editLugarChecado(id){
            if (id===0) {
                this.lugarChecado = {IdLugarChecado:0, Descripcion:''}
            }else{
                this.lugarChecado = await http.get(`catalogos/lugaresChecado/${id}`)
            }
            this.edit=true
        },
        async saveLugarChecado(){
            await http.post('catalogos/lugarChecado',this.lugarChecado);
            this.edit =false
            this.initialize();
        },
        async showLugarChecado(id){
            this.lugarChecado = await http.get(`catalogos/lugaresChecado/${id}`)
            this.del=true
        },
        async delLugarChecado(){
            await http.delete(`catalogos/delLugarChecado/${this.lugarChecado.IdLugarChecado}`)
            this.del =false
            this.initialize();
        }
    },
    created(){
        this.initialize();
    },
}
</script>